<template>
  <div class="c-m-c" :style="{ width: contentWidth + 'px' }">
    <div class="msg" v-if="!imgs || status == 'preparing'">
      <spinner></spinner>
    </div>
    <div v-else-if="imgs.length > 0">
      <div class="c-imgs">
        <album-img
          v-for="(item, idx) in pickups"
          :ref="`p-${idx}`"
          :ym="idx == 0 ? ym : 0"
          :key="idx"
          :item="item"
          :width="pickupWidth"
          type="pickup"
          :class="pickupClass"
          :alwaysTime="true"
          @click="onImgClicked"
        ></album-img>
        <div v-for="i in pickupDummyCount" :class="pickupClass" :key="`d${i}`"></div>
      </div>
      <div class="c-imgs">
        <album-img
          v-for="(item, idx) in imgsLoaded"
          :ref="`t-${idx}`"
          :key="idx"
          :item="item"
          :width="thumbWidth"
          type="thumb"
          :class="thumbClass"
          @click="onImgClicked"
        ></album-img>
        <div v-for="i in thumbDummyCount" :key="`d${i}`" :class="thumbClass"></div>
      </div>
      <tail-loader ref="tl" v-if="imgs" :srcs="imgs" :unit="thumbCount * 5" v-model="imgsLoaded" />
    </div>
    <div v-else row wrap class="msg">
      <v-flex xs12>
        {{ $T('common.no_data') }}
      </v-flex>
    </div>
  </div>
</template>

<script>
import { CONST } from '../../constant';
import albumImgComponent from './AlbumImgComponent.vue';

export default {
  components: {
    'album-img': albumImgComponent,
  },
  props: {
    inview: { type: Boolean, required: true },
    error: { type: Boolean, required: false },
    data: { type: Object, required: true },
    ym: { type: Number, required: true },
  },
  data() {
    return {
      imgs: this.data.d ? this.data.d : null,
      imgsLoaded: [],
      pickups: [],
      contentWidth: this.getContentWidth(),
      activateLoop: null,
      allActivated: false,
      allImgs: null,
      activateReserved: false,
      scrollEvent: _.throttle(this.onScroll, 100, { leading: true, trailing: true }),
    };
  },
  beforeDestroy() {
    this.stopActivation();
    document.removeEventListener('scroll', this.scrollEvent);
  },
  watch: {
    w(newValue, oldValue) {
      this.contentWidth = this.getContentWidth();
    },
    y(newValue, oldValue) {
      if (this.activatable) {
        this.startActivation();
      }
    },
    yyyymm(newValue, oldValue) {
      if (newValue == this.ym) {
        this.$nextTick(function() {
          this.startActivation();
        });
        document.addEventListener('scroll', this.scrollEvent);
      } else {
        this.stopActivation();
        document.removeEventListener('scroll', this.scrollEvent);
        var tl = this.$refs.tl;
        if (tl) {
          var self = this;
          setTimeout(() => {
            if (tl && self.ym != self.yyyymm) tl.reset();
          }, 2000);
        }
      }
    },
    inview(newValue, oldValue) {
      if (newValue) {
        this.startActivation();
      }
    },
    error(newValue, oldValue) {
      if (newValue) {
        console.error('failed to get data');
        this.errGetData();
      }
    },
    parentImgs(newValue, oldValue) {
      // update imgs only when changed.
      console.log(`got data for ${this.ym}`);
      if (!newValue) return;
      if (!this.imgs) return (this.imgs = newValue);
      if (newValue.length != this.imgs.length) {
        console.log(`imgs count changed from[${this.imgs.length}] to [${newValue.length}] for ${this.ym}`);
        this.imgs = newValue;
        return;
      }
      if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
        console.log(`imgs content changed on server. change images for ${this.ym}!`);
        this.imgs = newValue;
        return;
      }
      console.log(`server data not changed for ${this.ym}!`);
    },
    imgs(newValue, oldValue) {
      this.allActivated = false;
      this.setPickup(newValue);
      this.$nextTick(function() {
        this.allActivated = false;
        this.allImgs = null;
        if (this.activatable) {
          this.startActivation();
        }
      });
    },
    imgsLoaded(n, o) {
      this.$store.commit('SET_TABYM_ADJUST', time());
    },
    pickupCount(newValue, oldValue) {
      this.allActivated = false;
      this.setPickup(this.imgs);
      this.$nextTick(function() {
        this.allActivated = false;
        this.allImgs = null;
        if (this.activatable) {
          this.startActivation();
        }
      });
    },
  },
  mounted: function() {
    this.setPickup(this.imgs);
    if (this.activatable) {
      this.$nextTick(function() {
        this.startActivation();
      });
    }
    if (this.ym == this.yyyymm) {
      document.addEventListener('scroll', this.scrollEvent);
    }
  },
  computed: {
    activatable() {
      return this.yyyymm == this.ym || this.activateReserved;
    },
    yyyymm() {
      return this.$store.state.tools.yyyymm;
    },
    status() {
      // 'preparing' || 'cache' || 'clientdb' || 'done'
      return this.data.s;
    },
    parentImgs() {
      return this.data.d;
    },
    pickupCount() {
      var c = Math.ceil((this.contentWidth + 10) / CONST.img_size.pickup);
      return this.adjustCount(c, 1);
    },
    pickupClass() {
      return `v${this.pickupCount}`;
    },
    pickupDummyCount() {
      var mod = -this.pickups.length % this.pickupCount;
      return mod == 0 ? 0 : mod + this.pickupCount;
    },
    thumbCount() {
      var c = Math.ceil((this.contentWidth + 10) / CONST.img_size.thumb);
      return this.adjustCount(c, 3);
    },
    thumbClass() {
      return `v${this.thumbCount}`;
    },
    thumbDummyCount() {
      var mod = -this.imgs.length % this.thumbCount;
      return mod == 0 ? 0 : mod + this.thumbCount;
    },
    pickupWidth() {
      return this.contentWidth / this.pickupCount;
    },
    thumbWidth() {
      return this.contentWidth / this.thumbCount;
    },
  },
  methods: {
    onScroll() {
      this.range = 0;
      if (this.activateLoop) return;
      this.allActivated = false;
      this.startActivation();
    },
    getContentWidth() {
      var d = document.getElementById('album-ym');
      if (d) return d.clientWidth;
      return document.getElementById('c-root').clientWidth - (this.leTbS ? 0 : 2);
    },
    adjustCount(c, min) {
      return c < min ? min : c > 12 ? 12 : c;
    },
    setPickup(imgs) {
      if (!imgs) return;
      if (this.pickups.length == this.pickupCount) {
        var allOk = true;
        for (var img of this.pickups) {
          if (!this.inImgs(img.id)) {
            allOk = false;
            break;
          }
        }
        if (allOk) {
          return;
        }
      }
      if (imgs.length <= this.pickupCount) {
        this.pickups = imgs;
        return;
      }
      var idxs = [];
      for (var i = 0, n = imgs.length; i < n; i++) {
        idxs.push(i);
      }
      var rands = this.random(imgs, this.pickupCount);
      rands.sort((a, b) => {
        if (a.ts && b.ts) {
          if (a.ts < b.ts) return -1;
          if (a.ts > b.ts) return 1;
        }
        return a.id < b.id ? -1 : 1;
      });
      this.pickups = rands;
    },
    inImgs(id) {
      if (!this.imgs) return false;
      for (var img of this.imgs) {
        if (img.id == id) return true;
      }
      return false;
    },
    random(array, num) {
      var arr = [].concat(array);
      var r = [];
      for (var i = 0; i < num; i++) {
        var idx = Math.floor(Math.random() * arr.length);
        r.push(arr[idx]);
        arr.splice(idx, 1);
      }
      return r;
    },
    onImgClicked(item) {
      this.$store.commit('OPEN_VIEWER', { item: item, items: this.imgs.concat() });
    },
    startActivation() {
      if (this.allActivated) {
        this.activateReserved = true;
        this.$emit('allActivated', this.ym);
        // console.log(`already activated all ${this.ym}`);
        return;
      }
      console.log(`start activation ${this.ym}`);
      this.$emit('activateStarted', this.ym);
      if (this.activateLoop) clearInterval(this.activateLoop);
      this.activateLoop = null;

      this.range = 0;
      var self = this;
      if (this.activateAndIsFinished()) return;
      this.activateLoop = setInterval(function() {
        self.activateAndIsFinished();
        if (self.range > self.h && self.activateLoop) {
          console.log(`stop activation ${self.ym} over ${self.h}`);
          clearInterval(self.activateLoop);
          self.activateLoop = null;
        }
      }, 20);
    },
    getAll() {
      if (!this.imgs) return null;
      if (this.allImgs) return this.allImgs;
      var err = false;
      var all = [];
      for (var i = 0, n = this.pickups.length; i < n; i++) {
        var t = this.$refs[`p-${i}`];
        if (t && t.length == 1) all.push(t[0]);
        else err = true;
      }
      for (var i = 0, n = this.imgs.length; i < n; i++) {
        var t = this.$refs[`t-${i}`];
        if (t && t.length == 1) all.push(t[0]);
        else err = true;
      }
      if (!err) this.allImgs = all;
      return all;
    },
    activateAndIsFinished() {
      console.log(`activate ${this.ym} with range ${this.range}`);
      if (this.activate()) this.range += 200;
      if (!this.allActivated) return false;
      console.log(`all activated ${this.ym}`);
      this.$emit('allActivated', this.ym);
      if (this.activateLoop) {
        clearInterval(this.activateLoop);
        this.activateLoop = null;
      }
      return true;
    },
    activate() {
      var all = this.getAll();
      if (!all) return false;
      var allLoaded = true;
      var allDone = true;
      for (var i = 0, n = all.length; i < n; i++) {
        if (!all[i].activate(this.range)) allLoaded = false;
        if (all[i].needActivate && !all[i].activated) allDone = false;
      }
      if (allDone && this.allImgs != null) this.allActivated = true;
      return allLoaded;
    },
    stopActivation() {
      this.activateReserved = false;
      if (this.activateLoop) {
        console.log(`stop activation ${this.ym}`);
        clearInterval(this.activateLoop);
        this.activateLoop = null;
      }
    },
  },
};
</script>

<style scoped>
.c-m-c {
  min-height: calc(100vh - 220px);
  position: relative;
}
.le-tbs .c-m-c {
  min-height: calc(100vh - 156px);
}
.c-m-c .msg {
  position: absolute;
  top: calc(50% - 40px);
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 20px;
  color: rgba(0, 0, 0, 0.54);
}
.c-imgs {
  display: flex;
  align-content: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.c-imgs .mx-auto {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>
